import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { CashFund } from '../state/types'

export const useCashFundLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllCashFunds = (active = false) => getList(TableName.CASH_FUNDS, active) as CashFund[]

        const findCashFund = (id?: string) => find(TableName.CASH_FUNDS, id) as O<CashFund>

        const loadAllCashFunds = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.CASH_FUNDS, options)
            return response.dataTypes as CashFund[]
        }

        const loadCashFund = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.CASH_FUNDS, id, dbRequest) as Promise<O<CashFund>>
        }
        
        return {
            findAllCashFunds,
            findCashFund,
            loadAllCashFunds,
            loadCashFund
        }
    }
}
